(function() { window.GUID_21ae724b_17ec_44e3_a345_9b6993c1ee9c = { getGuid: function() { return "21ae724b-17ec-44e3-a345-9b6993c1ee9c"; } }; })();
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        class ImageCropperPersona {
            static Create(param, extraParam) {
                // TODO :
                //      Définir quelle est la taille par défaut selon le type d'image.
                //      Les tailles ci-dessous sont simplement des suggestions de taille basées sur le format rendu par les "PictureHelper" de persona/event.
                let imageType;
                if (typeof param.ImageType === "string") {
                    imageType = CS.Entity.General.ImageHistoryTypeEnum[param.ImageType];
                }
                else {
                    imageType = param.ImageType;
                }
                switch (imageType) {
                    case CS.Entity.General.ImageHistoryTypeEnum.ProfilPicture:
                        param.CroppingSize = CS.GlobalConst.PictureSizes.PersonOriginalSize;
                        //Voir si on affiche l'overlay pour la photo de profil aussi ...
                        break;
                    case CS.Entity.General.ImageHistoryTypeEnum.Person:
                        param.CroppingSize = CS.GlobalConst.PictureSizes.PersonOriginalSize;
                        param.ImageOverlayUrl = "/cdn/cs/images/overlay-player.png";
                        param.SaveOverlay = false;
                        break;
                    case CS.Entity.General.ImageHistoryTypeEnum.Team:
                        param.CroppingSize = CS.GlobalConst.PictureSizes.TeamOriginalSize;
                        break;
                    case CS.Entity.General.ImageHistoryTypeEnum.SportEvent:
                        param.CroppingSize = CS.GlobalConst.PictureSizes.EventOriginalSize;
                    default:
                        // Si rien n'est fourni, une taille par défaut?
                        break;
                }
                return Controls.ImageCropper.Create(param, extraParam);
            }
        }
        Controls.ImageCropperPersona = ImageCropperPersona;
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=image-cropper-persona.js.map
